module.exports = __webpack_public_path__ + "static/ada5-e608304a3a0f48dc38147a1f3e2ff738.jpg";